//qzkt/course/courseAll
import HttpUtils from '../utils/HttpUtils'

//获取所有课程列表
const getList = (data: {
  pageNum:string,
  pageSize: string,
  grade?: string,
  course?: string,
  term?: string,
  name?:string,
})=>{
  return HttpUtils.post("/qzkt/course/courseAll", {
    pageNum: data.pageNum,
    pageSize: data.pageSize,
    grade: data.grade,
    course: data.course,
    term: data.term,
    name: data.name,
    projectId: 6
  })
}

//获取课程详情
const getDetail = (id:string|number)=>{
  return HttpUtils.post("/qzkt/course/courseInfo?id=" + id)
}

const isActive = (courseId:string) => {
  ///qzkt/user/courseIsActive
  return HttpUtils.post("qzkt/user/courseIsActive", {
    projectId: 6,
    courseId
  })
}

const activeCourse = (data:{courseId:string,code:string}) => {
  return HttpUtils.post("/qzkt/user/active", {
    projectId: 6,
    courseId: data.courseId,
    code: data.code
  })
}


const selectCourseByChapterId = (chapterId:string) => {
  return HttpUtils.post("/qzkt/course/selectChapter?id=" + chapterId)
}

const CourseService = {
  getList,
  getDetail,
  isActive,
  activeCourse,
  selectCourseByChapterId
}

export default CourseService;